import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { LottieAnimation } from "../lottie/LottieAnimation";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
const LottieLoader = ({
  loading,
  boardWidth = 300,
  message = "Please wait...",
  lottieUrl = "https://res.cloudinary.com/dnlgtek2a/raw/upload/v1743418492/Lottie/analysis.json",
}) => {
  const { t } = useTranslation();
  if (!loading) return null;

  return (
    <Box
      sx={{
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
      }}
    >
      <LottieAnimation
        path={lottieUrl}
        width={boardWidth}
        height={boardWidth}
        autoplay
        loop
      />
      <Paper
        sx={{
          p: 1,
          m: 1,
          textAlign: "center",
          background: "#333",
          maxWidth: 400,
          width: "90vw",
        }}
      >
        <Typography variant="h6" sx={{ color: "#fff" }}>
          {t(message)}
        </Typography>
      </Paper>
    </Box>
  );
};

LottieLoader.propTypes = {
  loading: PropTypes.bool.isRequired,
  boardWidth: PropTypes.number,
  message: PropTypes.string,
  lottieUrl: PropTypes.string,
};

export default LottieLoader;
